module.exports = "https://tutorchat.chegg.com/static/media/ic-pen.2818b850.svg";